<div
  class="corner-dots-container"
  [style.width.px]="width"
  [style.height.px]="height"
  [style.position]="'absolute'"
  [style.top]="'0'"
  [style.left]="'0'"
  [style.pointer-events]="'none'"
  [style.overflow]="'visible'"
>
  <!-- Top Left Corner -->
  <div
    class="corner-handle"
    data-overlay-ui="corner-handle"
    data-corner="tl"
    [style.position]="'absolute'"
    [style.left.px]="cornerPositions.topLeft.x - 6"
    [style.top.px]="cornerPositions.topLeft.y - 6"
    (mousedown)="startDrag('topLeft', $event)"
    (touchstart)="startDrag('topLeft', $event)"
  ></div>

  <!-- Top Right Corner -->
  <div
    class="corner-handle"
    data-overlay-ui="corner-handle"
    data-corner="tr"
    [style.position]="'absolute'"
    [style.left.px]="cornerPositions.topRight.x - 6"
    [style.top.px]="cornerPositions.topRight.y - 6"
    (mousedown)="startDrag('topRight', $event)"
    (touchstart)="startDrag('topRight', $event)"
  ></div>

  <!-- Bottom Left Corner -->
  <div
    class="corner-handle"
    data-overlay-ui="corner-handle"
    data-corner="bl"
    [style.position]="'absolute'"
    [style.left.px]="cornerPositions.bottomLeft.x - 6"
    [style.top.px]="cornerPositions.bottomLeft.y - 6"
    (mousedown)="startDrag('bottomLeft', $event)"
    (touchstart)="startDrag('bottomLeft', $event)"
  ></div>

  <!-- Bottom Right Corner -->
  <div
    class="corner-handle"
    data-overlay-ui="corner-handle"
    data-corner="br"
    [style.position]="'absolute'"
    [style.left.px]="cornerPositions.bottomRight.x - 6"
    [style.top.px]="cornerPositions.bottomRight.y - 6"
    (mousedown)="startDrag('bottomRight', $event)"
    (touchstart)="startDrag('bottomRight', $event)"
  ></div>
</div>
